import React from "react";
import TimelineItemProjects from "./TimelineItem";
import TimelineHeader from "./TimelineHeader";
import Resume from "../../resume.json";

function TimelineProjects() {
  return (
    <div className="timeline is-centered">
      <header className="timeline-header">
        <span className="tag is-medium is-dark">
          {new Date().getFullYear()}
        </span>
      </header>
      <div className="timeline-item">
        <div className="timeline-marker is-success"></div>
        <div className="timeline-content"></div>
      </div>
      {Resume.projects
        .map(item => {
          return new Date(item.startDate).getFullYear();
        }).filter((value, index, self) => self.indexOf(value) === index)
        .map((year, i) => {
          let content = [];
          content.push(
            <TimelineHeader key={i} year={year}/>
          );
          content.push(
            Resume.projects
              .filter(projects => new Date(projects.startDate).getFullYear() === year)
              .map((item, j) => {
                return (
                  <TimelineItemProjects
                    key={j}
                    date={new Date(item.startDate).toLocaleString("fr-FR", {
                      month: "long",
                      year: "numeric"
                    })}
                    company={item.company}
                    highlights={item.highlights}
                    position={item.position}
                    summary={item.summary}
                  />
                );
              })
          );
          return content;
        })}
    </div>
  );
}

export default TimelineProjects;
